import { Component, Input } from '@angular/core';
import { AppLockModel } from './app-lock.model';

@Component({
    selector: 'pace-core-app-lock',
    templateUrl: './app-lock.component.html',
    styleUrl: './app-lock.component.scss',
})
export class AppLockComponent {
    @Input()
    public model: AppLockModel;
}
